export const DASHBOARD_OPEN = 'DASHBOARD_OPEN'
export const LOCATION_OPEN = 'LOCATION_OPEN'
export const PRODUCTS_OPEN = 'PRODUCTS_OPEN'
export const TRANSACTION_OPEN = 'TRANSACTION_OPEN'
export const CUSTOMERS_OPEN = 'CUSTOMERS_OPEN'
export const HELP_OPEN = 'HELP_OPEN'
export const PROFILE_OPEN = 'PROFILE_OPEN'
export const PAYMENT_OPEN = 'PAYMENT_OPEN'